import { sortBy } from 'lodash';
import { FETCH_CATEGORIES_SUCCESS } from './fetch-categories';
import { CREATE_CATEGORY_SUCCESS } from './create-category-types';
import { ADD_CATEGORY } from './add-category';
import { addOrReplaceByKeys } from '../../services/array';
import { FETCH_CATEGORY_SUCCESS } from '../../../feed-page/actions/fetch-category';

const SORT_BY = 'rank';

const categories = (state = [], { type, payload } = {}) => {
  switch (type) {
    case FETCH_CATEGORIES_SUCCESS:
      return sortBy(payload, SORT_BY);

    case FETCH_CATEGORY_SUCCESS:
    case ADD_CATEGORY:
    case CREATE_CATEGORY_SUCCESS:
      return sortBy(addOrReplaceByKeys(state, payload, '_id'), SORT_BY);

    default:
      return state;
  }
};

export default categories;
